import React from 'react';
import '../../../styles/form/unsavedreport.scss';

const UnsavedReport = ({ manager }) => {
  const form = manager.getData();
  const dirtyFields = [];

  Object.keys(form).forEach(fieldName => {
    const field = form[fieldName];
    // Aggregate & Auto Calculate fields don't count
    if (field.calculated || field.noSubmit) {
      return;
    }

    if (field.dirty === true) {
      console.log('Dirty field', field);
      let index = 0;
      // Sometimes stuff gets marked dirty just for submitting (i.e. relative table data)
      if (Array.isArray(field.data)) {
        for (const rowData of field.data) {
          if (rowData !== field.originalValue[index]) {
            dirtyFields.push(form[fieldName]);
            return;
          }
          index++;
        }
      } else {
        if (field.data !== field.originalValue) {
          dirtyFields.push(form[fieldName]);
        }
      }
    }
  });

  const renderValue = (valueField, field) => {
    const value = field[valueField];

    if (Array.isArray(value)) {
      return value.map((v, idx) => {
        const key = `${valueField}${idx}`;
        if (field.originalValue[idx] === field.data[idx]) {
          return <span key={key} />;
        }
        return (
          <div key={key}>
            [{idx + 1}] {v}
          </div>
        );
      });
    }

    return value;
  };

  return (
    <div className="unsaved-report">
      <table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Original</th>
            <th>New</th>
          </tr>
        </thead>
        <tbody>
          {dirtyFields.map(field => {
            return (
              <tr key={field.name}>
                <td>{field.label}</td>
                <td>{renderValue('originalValue', field)}</td>
                <td>{renderValue('data', field)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UnsavedReport;
